import { Grid, Tab, Tabs } from '@mui/material'
import { useEffect, useContext } from 'react'
import DadosProposta from './DadosProposta'
import Itens from './Itens'
import TerapiasComplementares from './TerapiasComplementares'
import Anexos from './Anexos'
import { PropostaContext } from './index'
import HeaderTabs from './HeaderTabs'
import Paciente from './Paciente'
import DivisaoEmpresaNF from './DivisaoEmpresaNF'
import FormaPagamento from './FormaPagamento'

const Edicao = () => {
  const { tab, dadosEdicao, dispatch, atualizaTotais } =
    useContext(PropostaContext)

  useEffect(() => {
    if (dadosEdicao?.idAtendimento) {
      atualizaTotais(dadosEdicao?.idAtendimento)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Tabs
          value={tab}
          onChange={(_, v) => dispatch({ type: 'setTab', value: v })}
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab value={0} label="Proposta" />
          <Tab
            disabled={!dadosEdicao?.idAtendimento}
            value={6}
            label="Pagamentos"
          />
          <Tab
            disabled={!dadosEdicao?.idAtendimento}
            value={4}
            label="Dependentes"
          />
          <Tab
            disabled={!dadosEdicao?.idAtendimento}
            value={1}
            label="Pacote"
          />
          <Tab
            disabled={!dadosEdicao?.idAtendimento}
            value={2}
            label="Terapias Complementares"
          />
          <Tab
            disabled={!dadosEdicao?.idAtendimento}
            value={3}
            label="Anexos"
          />
        </Tabs>
      </Grid>
      <Grid item xs={12}>
        {tab > 0 && <HeaderTabs />}
        <div style={{ display: tab === 0 ? 'block' : 'none' }}>
          <DadosProposta />
        </div>

        <div style={{ display: tab === 1 ? 'block' : 'none' }}>
          <Itens />
        </div>
        <div style={{ display: tab === 2 ? 'block' : 'none' }}>
          <TerapiasComplementares />
        </div>
        {tab === 3 && <Anexos />}
        <div style={{ display: tab === 4 ? 'block' : 'none' }}>
          <Paciente />
        </div>
        <div style={{ display: tab === 5 ? 'block' : 'none' }}>
          <DivisaoEmpresaNF />
        </div>
        <div style={{ display: tab === 6 ? 'block' : 'none' }}>
          <FormaPagamento />
        </div>
      </Grid>
    </Grid>
  )
}

export default Edicao
